import type { MouseEvent, ReactNode } from 'react';
import { isDesktopRuntime } from '@/desktop/desktopDetection';
import { openExternal } from '@/desktop/desktopOpenExternal';

/**
 * A link to one of the website's legal pages (F-0554). It opens outside the app: in a new tab in a
 * browser, and in the system browser from the desktop window, which has no tabs.
 *
 * Without an address (the deployment named no website, or has not answered yet) the words stay,
 * so a sentence that names the Terms still reads.
 */
export function LegalLink({
  href,
  className,
  children,
}: {
  href: string | null | undefined;
  className?: string;
  children: ReactNode;
}) {
  if (!href) return <span className={className}>{children}</span>;
  function open(event: MouseEvent<HTMLAnchorElement>) {
    if (!isDesktopRuntime()) return;
    event.preventDefault();
    void openExternal(href!);
  }
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className={className} onClick={open}>
      {children}
    </a>
  );
}
